<section class="error-detail-section">
    <div class="container-fluid h-100 d-flex flex-column p-0">
    
        <!-- Full Log Message Row -->
        <div class="row flex-grow-1">
            <div class="col col-xl-6 col-lg-6 col-md-8 col-sm-10 col-10">
                <p class="text-wrap-balance">
                    <strong>Full Log Message:</strong> 
                    {{ errorData()?.logMessage }}
                </p>
            </div>
        </div>
    
        <!-- Error Details Grid -->
        <div class="row flex-grow-1">
            <!-- Column 1: Integration Details -->
            <div class="col-3 col-xl-2 col-lg-2 details-grid-column">
                <p><strong>Integration Name:</strong> {{ integrationDisplayName() }}</p>
                <p><strong>Integration ID:</strong> {{ integrationId() }}</p>
                <p><strong>Client Name:</strong> {{ clientDisplayName() }}</p>
                <p><strong>Client ID:</strong> {{ clientId() }}</p>
                <p><strong>Current Integration Server:</strong> {{ integrationServerId() }}</p>
            </div>
        
            <!-- Column 2: Error Metadata -->
            <div class="col-3 col-xl-2 col-lg-2 details-grid-column">
                <p><strong>Error Message ID:</strong> {{ errorData()?.integrationErrorId }}</p>
                <p><strong>Server Error Occurred On:</strong> {{ errorData()?.serverId }}</p>
                <p><strong>Auto Resolve On Successful Integration:</strong> {{ errorData()?.automatedResolution }}</p>
                <p><strong>Data-Source Type:</strong> {{ dataSourceTypeId() }}</p>
                <p><strong>Function:</strong> {{ errorData()?.functionWithin }}</p>
            </div>
            
            <!-- Column 3: Status & Resolution -->
            <div class="col-3 col-xl-2 col-lg-2 details-grid-column">
                <p><strong>Action Needed:</strong> {{ errorData()?.actionNeeded }}</p>
                <p><strong>Critical Error:</strong> {{ errorData()?.criticalError }}</p>
                
                @if (isResolved()) {
                    <p><strong class="text-green">Resolved On:</strong> {{ formatDate(errorData()?.resolutionDate) }}</p>
                    <p><strong class="text-green">Resolution Comment:</strong> {{ errorData()?.resolutionComment }}</p>
                }
            </div>
        </div>
    
        <!-- JIRA and Actions Row -->
        <div class="row flex-grow-1">
            <div class="col col-lg-10">
                <div class="action-display d-flex flex-wrap h-100">
                    
                    <!-- JIRA Ticket Actions when no URL exists -->
                    @if (!hasJiraUrl() && !showJiraInput()) {
                        <app-lt-button 
                            (click)="toggleJiraInput()"
                            [disabled]="isJiraOperationInProgress()"
                            class="button-standard"
                            [label]="'Add Existing JIRA Ticket URL'"
                            appearance="elevated"></app-lt-button>
                        
                        <button class="button-standard" 
                                matButton="elevated"
                                (click)="generateJiraTicket()"
                                [disabled]="isJiraOperationInProgress()">
                            @if (isGeneratingJira()) {
                                Generating...
                            } @else {
                                Generate JIRA Ticket
                            }
                        </button>
                    }
                    
                    <!-- JIRA URL Input Form -->
                    @if (showJiraInput()) {
                        <mat-form-field class="form-field-full-width example-full-width" appearance="fill">
                            <mat-label>JIRA Ticket URL</mat-label>
                            <input matInput 
                                    [value]="jiraUrl()"
                                    (input)="updateJiraUrl($event)"
                                    placeholder="Enter JIRA URL" 
                                    title="JIRA Ticket URL">
                        </mat-form-field>
                        
                        <button 
                            (click)="toggleJiraInput()"
                            class="button-standard"
                            matButton="elevated">
                            Cancel
                        </button>
                    
                        <button class="button-standard" 
                                matButton="elevated"
                                (click)="saveJiraUrl()"
                                [disabled]="!jiraUrl().trim() || isJiraOperationInProgress()">
                            @if (isUpdating()) {
                                Updating...
                            } @else {
                                Update Error
                            }
                        </button>
                    }
                    
                    <!-- Display existing JIRA URL -->
                    @if (hasJiraUrl() && !showJiraInput()) {
                        <div class="text-wrap">
                            <strong>JIRA Ticket:</strong>
                            <a [href]="savedJiraUrl()" 
                                target="_blank"
                                class="text-decoration-none">
                                {{ savedJiraUrl() }}
                            </a>
                        </div>
                        
                        <app-lt-button 
                            (click)="toggleJiraInput()"
                            class="button-standard"
                            [label]="'Update JIRA Ticket URL'"
                            appearance="elevated"></app-lt-button>
                    }
                    
                    <!-- Client Navigation -->
                    <a [routerLink]="clientNavigationRoute()" target="_blank">
                        <app-lt-button 
                            class="button-standard"
                            [label]="'Go To Client'"
                            appearance="elevated"></app-lt-button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>